module.exports = __webpack_public_path__ + "img/shreerastu.e98faa1b.jpg";